
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { TaskActionModel } from './Entities.GormCrm.TaskAction';
import { Model, ModelProperty } from 'models/Model';


export class RescheduleTaskActionRequestModel extends Model<RescheduleTaskActionRequestModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'updatedTaskAction', type: 'TaskActionModel', languageString: 'rescheduleTaskActionRequest.property.updatedTaskAction', isHidden: true, isObject: true, new: () => { return new TaskActionModel }, properties: () => { return TaskActionModel.classProperties } },
		{ name: 'logComments', type: 'string', languageString: 'rescheduleTaskActionRequest.property.logComments' },
		{ name: 'logEntryStatus', type: 'string', languageString: 'rescheduleTaskActionRequest.property.logEntryStatus' }
	];
	[key: string]: any;
	
	public updatedTaskAction?: TaskActionModel;
	public logComments: string;
	public logEntryStatus?: string;
    
	constructor(){
		super();
		this.updatedTaskAction = undefined;
		this.logComments = '';
		this.logEntryStatus = undefined;
		
	}
	getProperties(){
		return RescheduleTaskActionRequestModel.classProperties;
	}
}

